import { Formik } from "formik";
import {
  Button,
  Chip,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from "@mui/material";
import CustomField from "../shared/CustomTextField";
import { useStore } from "../../hooks/store";
import Styles from "./Form.module.css";
import { createElement, useState } from "react";
import {
  deleteNewsToTheme,
  postNews,
  postNewsToTheme,
  updateNews,
} from "../../utils/API/newsMethods";
import VideoUploader from "../VideoUploader";
import { endpoints, uploaderType } from "../../utils/config";
import * as Icons from "@mui/icons-material";
import * as React from "react";
import { Theme, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function NewsForm({ categoryList }) {
  const store = useStore();
  const newsData = store.form.dataToUpdate;
  const [initValues, setValues] = useState(
    (newsData && {
      ...newsData,
      category: newsData.category
        ? newsData.category.map((item) => String(item.id))
        : [],
    }) || {
      id: null,
      title: null,
      short_text: null,
      full_text: null,
      preview_src: null,
    }
  );

  const submitNews = (values) => {
    postNews(values).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }

      store.setAlert(data, "error");
    });
  };

  const submitUpdatedNews = (values) => {
    updateNews(values.id, values).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }

      store.setAlert(data, "error");
    });
  };

  const wrapperStyle = newsData && { flexDirection: "row" };

  return (
    <Formik
      initialValues={initValues}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        if (newsData) {
          submitUpdatedNews(values);
          values.category.forEach((categoryId) => {
            const current = initValues.category.find((id) => id == categoryId);
            !current && postNewsToTheme(values.id, categoryId);
          });

          initValues.category.forEach((id) => {
            const current = values.category.find((categoryId) => {
              return id == categoryId;
            });
            !current && deleteNewsToTheme(values.id, id);
          });
        } else {
          submitNews(values);
        }

        setSubmitting(false);
      }}>
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        handleReset,
        submitForm,
        setFieldValue,
      }) => (
        <>
          <p>{newsData ? "Изменение новости" : "Создание новости"}</p>
          <form onSubmit={handleSubmit}>
            <div
              className={Styles.form_content}
              style={{ flexDirection: "row" }}>
              <div className={Styles.form_fields}>
                <CustomField
                  name="title"
                  label="Заголовок новости"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.title}
                />

                <CustomField
                  multiline
                  rows={12}
                  name="full_text"
                  label={"Текст новости"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.full_text}
                />

                {newsData && (
                  <FormControl fullWidth>
                    <InputLabel id="demo-multiple-chip-label">
                      Категории
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-chip"
                      id="category"
                      name="category"
                      multiple
                      value={values.category}
                      onChange={handleChange}
                      input={
                        <OutlinedInput id="select-multiple-chip" label="Chip" />
                      }
                      renderValue={(category) => {
                        return (
                          <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                            {category.map((cat) => {
                              const currentCategory = categoryList.find(
                                (item) => {
                                  return cat == item.id;
                                }
                              );

                              const {
                                main_color,
                                text_color,
                                name,
                                icon_name,
                              } = currentCategory;
                              return (
                                <MenuItem key={cat.id} value={cat}>
                                  <Chip
                                    sx={{
                                      backgroundColor: main_color,
                                      color: text_color,
                                      borderRadius: "8px",
                                    }}
                                    label={name}
                                    icon={
                                      Icons[icon_name]
                                        ? createElement(Icons[icon_name])
                                        : null
                                    }
                                  />
                                </MenuItem>
                              );
                            })}
                          </Box>
                        );
                      }}
                      MenuProps={MenuProps}>
                      {categoryList.map((fullCategory) => {
                        const { main_color, text_color, name, icon_name } =
                          fullCategory;
                        return (
                          <MenuItem
                            key={fullCategory.id}
                            value={fullCategory.id}>
                            <Chip
                              sx={{
                                backgroundColor: main_color,
                                color: text_color,
                                borderRadius: "8px",
                              }}
                              label={name}
                              icon={
                                Icons[icon_name]
                                  ? createElement(Icons[icon_name])
                                  : null
                              }
                            />
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                )}
              </div>
              <div className={Styles.form_fields}>
                <CustomField
                  multiline
                  rows={4}
                  name="short_text"
                  label={"Краткое содержание"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.short_text}
                />
                <VideoUploader
                  type={uploaderType.image}
                  label={"Загрузить обложку новости"}
                  endpoint={"image/preview"}
                  onChange={(fileData) => {
                    values.preview_src = fileData.finalFilename;
                  }}
                  defaultSrc={values.preview_src}
                />
              </div>
            </div>
            <div className="form_actions">
              <Button onClick={handleReset}>Очистить</Button>
              <Button variant="contained" onClick={handleSubmit}>
                Применить
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
}
